export default __webpack_public_path__ + "static/media/Mobile_Scroll-1.b5d52a53.jpg";